import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PostOfficeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.785 15.498V22H11.97C17.508 22 22 17.542 22 11.969C22 6.458 17.508 2 11.97 2H11.293V3.053H11.723C15.108 3.053 17.939 5.839 17.939 9.245C17.939 12.65 15.169 15.436 11.785 15.498ZM2 11.969C2 7.449 4.954 3.672 9.077 2.434V21.566C4.954 20.328 2 16.551 2 11.969Z",
    fill: "currentColor"
  }));
}